
import * as defaultImport from "@splunk/react-icons/MagnifierMinus";
export * from "@splunk/react-icons/MagnifierMinus";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
